module.exports = __webpack_public_path__ + "img/2_263.3fd96817.png";